import TYPE from "./TYPE"

/**
 * ENTER_TYPE
 * CONTRACT_NUMBER
 * PMEMBER_CODE
 * CMEMBER_CODE
 */
export const URL = {

  SMART_ALL_01: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=WJTB&CONTRACT_NUMBER=M100005801&PMEMBER_CODE=ME-20190322171839183&CMEMBER_CODE=ME-20190322171839258&PM_CHECK=N",
  SMART_ALL_02: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=WJTB&CONTRACT_NUMBER=M100005708&PMEMBER_CODE=ME-20170321150852478&CMEMBER_CODE=ME-20170321150852869",
  SMART_ALL_03: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=WJTB&CONTRACT_NUMBER=M100007728&PMEMBER_CODE=ME-20201020141013741&CMEMBER_CODE=ME-20201020141013416&URL=topicLearning/THMA_05",
  SMART_ALL_04: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=WJTB&CONTRACT_NUMBER=M100004046&PMEMBER_CODE=ME-20201020140249039&CMEMBER_CODE=ME-20201020140249827&URL=courseLearning/list",
  SMART_ALL_05: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=WJTB&CONTRACT_NUMBER=M100002119&PMEMBER_CODE=ME-20160526152330594&CMEMBER_CODE=ME-20160526152330587&PM_CHECK=N",

  GM01: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10005625&CHILD_CSTMR_NO=MC1A005625&CNTRT_NO=M100005625",
  GM02: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10007122&CHILD_CSTMR_NO=MC1A007122&CNTRT_NO=M100007122&PM_CHECK=N",
  GM03: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10005434&CHILD_CSTMR_NO=MC1A005434&CNTRT_NO=M100005434",
  GM04: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10002141&CHILD_CSTMR_NO=MC1A002141&CNTRT_NO=M100002141",
  GM05: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10006090&CHILD_CSTMR_NO=MC1B006090&CNTRT_NO=M100006090",
  "문항검수": "https://dev-brs-fo-frontend.wjtb.kr/questionInspection/list?LAUNCH_TYPE=GM&CHN_CD=BRS1000&PARENT_CSTMR_NO=MP10005625&CHILD_CSTMR_NO=MC1A005625&CNTRT_NO=M100005625",
  // GM04: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM&CHN_CD=GLOBAL01&PARENT_CSTMR_NO=0022685193&CHILD_CSTMR_NO=0027101638&CNTRT_NO=0027101638",

  CPMODEL01: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=CP&CHN_CD=BRS1000&PARENT_CSTMR_NO=0099999999&CHILD_CSTMR_NO=CP00999999&CNTRT_NO=0025481045&CHILD_NM=김자녀&CHILD_YR=20080101",
  CPMODEL02: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=CP&CHN_CD=BRS1000&PARENT_CSTMR_NO=CP13608470&CHILD_CSTMR_NO=CPMB000015&CNTRT_NO=CPTEST0001&CHILD_NM=홍길동&CHILD_YR=20220530",
  

  // GB01: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=GLOBAL01&CONTRACT_NUMBER=M100002119&PMEMBER_CODE=ME-20160526152330594&CMEMBER_CODE=ME-20160526152330587&PM_CHECK=N",
  // GB02: "https://dev-brs-fo-frontend.wjtb.kr?ENTER_TYPE=GLOBAL01&CONTRACT_NUMBER=M100005801&PMEMBER_CODE=ME-20190322171839183&CMEMBER_CODE=ME-20190322171839258&PM_CHECK=N",

  GM_APP: "https://dev-brs-fo-frontend.wjtb.kr/?LAUNCH_TYPE=GM_APP&CHN_CD=BRS1000&PARENT_CSTMR_NO=0027765415&CHILD_CSTMR_NO=0027765440",
  GB_APP: "https://dev-brs-fo-frontend.wjtb.kr?LOCALE=ko&CHN_CD=GLOBAL01&LAUNCH_TYPE=GLOBAL01&APP_ID=CDCDC81B-7140-4C7C-AA98-05C0009EE118",

  SAMPLE: "/sample",
  NONE: "?PM_CHECK=N",

  KR_초기화 : { country_cd : 'KR', purchsYn : null, init : true },
  KR_로그인 : { country_cd : 'KR', purchsYn : null, init : false },
  KR_미결제 : { country_cd : 'KR', purchsYn : 'N', init : false },
  KR_결제 : { country_cd : 'KR', purchsYn : 'Y', init : false },
  US_초기화 : { country_cd : 'US', purchsYn : null, init : true },
  US_로그인 : { country_cd : 'US', purchsYn : null, init : false },
  US_미결제 : { country_cd : 'US', purchsYn : 'N', init : false },
  US_결제 : { country_cd : 'US', purchsYn : 'Y', init : false },
  GB_초기화 : { country_cd : 'GB', purchsYn : null, init : true },
  GB_로그인 : { country_cd : 'GB', purchsYn : null, init : false },
  GB_미결제 : { country_cd : 'GB', purchsYn : 'N', init : false },
  GB_결제 : { country_cd : 'GB', purchsYn : 'Y', init : false },
  IN_초기화 : { country_cd : 'IN', purchsYn : null, init : true },
  IN_로그인 : { country_cd : 'IN', purchsYn : null, init : false },
  IN_미결제 : { country_cd : 'IN', purchsYn : 'N', init : false },
  IN_결제 : { country_cd : 'IN', purchsYn : 'Y', init : false },
  PH_초기화 : { country_cd : 'PH', purchsYn : null, init : true },
  PH_로그인 : { country_cd : 'PH', purchsYn : null, init : false },
  PH_미결제 : { country_cd : 'PH', purchsYn : 'N', init : false },
  PH_결제 : { country_cd : 'PH', purchsYn : 'Y', init : false },
  ETC_초기화 : { country_cd : 'AE', purchsYn : null, init : true },
  ETC_로그인 : { country_cd : 'AE', purchsYn : null, init : false },
  ETC : { country_cd : 'AE', purchsYn : null, init : false }
}

export const EMAIL_LOGIN_TEST_RESP = {
  code: 'S000000',
  resp: {
    parentCstmrNo: "0025243182",
    accessToken: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIkRU5CYzhGUUFAd2p0Yi5uZXQiLCJhdGgiOlsiUk9MRV9VU0VSIl0sImNobiI6IkJSUzEwMDAiLCJtYnIiOiJNQlIyMDIxMDYwODE2MDAwMDcwOSIsImlzcyI6IndqdGhpbmtiaWciLCJpYXQiOjE2MjM4OTAwNzAsImV4cCI6MTYyMzk3NjQ3MH0.mFQudQRFccyo2lUObqEjIjxbyUtcK53KuAXwsd1Dywb6yqyFIbm3QKa9OBz3L_u_LR4cFc_Zt2zu_-8mIh225A",
    learner: [
      {
        birth: "201207",
        cstmrNo: "0025733155",
        gender: "M",
        name: "최지호",
      },
      {
        birth: "201307",
        cstmrNo: "0025733156",
        gender: "M",
        name: "최지구",
      }
    ]
  }
}